import { ControlsOf, FormGroupType } from '@app/core/utils/formgroup-type';
import { LocationAddressDto } from '@app/api/dmc';
import { FormControl, FormGroup } from '@angular/forms';

export function createInstallationLocationAddressForm(): FormGroupType<LocationAddressDto> {
  return new FormGroup<ControlsOf<LocationAddressDto>>({
    buildingNumber: new FormControl(),
    cityName: new FormControl(),
    country: new FormControl(),
    darReference: new FormControl(),
    floorIdentification: new FormControl(),
    municipalityCode: new FormControl(),
    postalCode: new FormControl(),
    roomIdentification: new FormControl(),
    streetCode: new FormControl(),
    streetName: new FormControl(),
    subDivisionName: new FormControl(),
    washInstructions: new FormControl(),
  });
}
